
import { combineReducers } from 'redux';
import jobList from 'store/reducers/jobList/jobList';
import jobListFilters from 'store/reducers/jobList/jobListFilters';
import jobListExcel from 'store/reducers/jobList/jobListExcel';

export default combineReducers({
  jobList,
  jobListFilters,
  jobListExcel
});